module.exports = __webpack_public_path__ + "media/images/en/build-5495977af4f7af6943c728061c3a5b86.png";